import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldTick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "shield-aura",
			d: "M13.3333 8C13.3333 11.2723 9.76402 13.6523 8.46532 14.4099C8.31772 14.496 8.24393 14.5391 8.13978 14.5614C8.05895 14.5787 7.94103 14.5787 7.8602 14.5614C7.75605 14.5391 7.68226 14.496 7.53466 14.4099C6.23596 13.6523 2.66666 11.2723 2.66666 8V4.81173C2.66666 4.27872 2.66666 4.01222 2.75383 3.78313C2.83084 3.58076 2.95598 3.40018 3.11843 3.25702C3.30232 3.09495 3.55186 3.00138 4.05093 2.81423L7.62546 1.47378C7.76406 1.4218 7.83335 1.39582 7.90465 1.38552C7.96788 1.37638 8.0321 1.37638 8.09533 1.38552C8.16663 1.39582 8.23592 1.4218 8.37452 1.47378L11.9491 2.81423C12.4481 3.00138 12.6977 3.09495 12.8816 3.25702C13.044 3.40018 13.1691 3.58076 13.2462 3.78313C13.3333 4.01222 13.3333 4.27872 13.3333 4.81173V8Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "shield-shell",
			d: "M13.3333 8C13.3333 11.2723 9.76402 13.6523 8.46532 14.4099C8.31772 14.496 8.24393 14.5391 8.13978 14.5614C8.05895 14.5787 7.94103 14.5787 7.8602 14.5614C7.75605 14.5391 7.68226 14.496 7.53466 14.4099C6.23596 13.6523 2.66666 11.2723 2.66666 8V4.81173C2.66666 4.27872 2.66666 4.01222 2.75383 3.78313C2.83084 3.58076 2.95598 3.40018 3.11843 3.25702C3.30232 3.09495 3.55186 3.00138 4.05093 2.81423L7.62546 1.47378C7.76406 1.4218 7.83335 1.39582 7.90465 1.38552C7.96788 1.37638 8.0321 1.37638 8.09533 1.38552C8.16663 1.39582 8.23592 1.4218 8.37452 1.47378L11.9491 2.81423C12.4481 3.00138 12.6977 3.09495 12.8816 3.25702C13.044 3.40018 13.1691 3.58076 13.2462 3.78313C13.3333 4.01222 13.3333 4.27872 13.3333 4.81173V8Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "shield-check",
			d: "M5.99999 7.66666L7.33332 9L10.3333 6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgShieldTick;
